import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { KYMW1708Component } from "./kymw1708.component";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { RegistMultipleCodeImageInfoService } from "./api-services/regist-multiple-code-image-info.service";

/**
 * 複数コード登録
 * 
 */
@NgModule({
  imports: [
    AppCommonsModule,
    CommonModule,
    FormsModule,
    PlessSharedModule,
  ],
  declarations: [
    KYMW1708Component
  ],
  providers: [
    RegistMultipleCodeImageInfoService,
  ],
})

export class KYMW1708Module {

}